"use client";

import { usePathname } from "next/navigation";
import {
  WorkspaceNameIconInput,
  type WorkspaceNameIconInputProps,
} from "@/app/components/WorkspaceNameIconInput";
import { AeraFieldLabel } from "@/app/components/ui/AeraFieldLabel";

export const WORKSPACE_BUSINESS_NAME_LABEL = "ชื่อร้าน / ธุรกิจ";
export const WORKSPACE_BUSINESS_NAME_SIGNIN_LABEL = "เริ่มจากชื่อร้านของคุณ";
export const WORKSPACE_NAME_ICON_EDIT_LABEL = "แก้ไข ชื่อร้าน / ธุรกิจ";
export const WORKSPACE_NAME_ICON_DEFAULT_PLACEHOLDER =
  "เช่น ร้านค้าออนไลน์ของฉัน";

export type WorkspaceNameIconFieldProps = WorkspaceNameIconInputProps & {
  /** Defaults to {@link WORKSPACE_BUSINESS_NAME_LABEL}. */
  label?: string;
  /** Extra classes on the outer gray card (e.g. `mb-6`). */
  wrapperClassName?: string;
};

function isSigninPath(pathname: string | null): boolean {
  if (!pathname) return false;
  return pathname === "/signin" || pathname.startsWith("/signin/");
}

export function WorkspaceNameIconField({
  label,
  wrapperClassName = "",
  placeholder = WORKSPACE_NAME_ICON_DEFAULT_PLACEHOLDER,
  className,
  ...inputProps
}: WorkspaceNameIconFieldProps) {
  const pathname = usePathname();
  const resolvedLabel =
    label ??
    (isSigninPath(pathname)
      ? WORKSPACE_BUSINESS_NAME_SIGNIN_LABEL
      : WORKSPACE_BUSINESS_NAME_LABEL);

  return (
    <div
      className={[
        "space-y-2",
        wrapperClassName,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <AeraFieldLabel as="label" size="2xl">
        {resolvedLabel}
      </AeraFieldLabel>
      <WorkspaceNameIconInput
        placeholder={placeholder}
        className={className}
        {...inputProps}
      />
    </div>
  );
}
